if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      // this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');

      // Form
      this.form = this.querySelector('form');      
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      // Variants
      this.variants = this.querySelector('.product__variants select');
      this.variants?.addEventListener('change', () => this.handleVariantSelect());

      // Tiered pricing price
      this.tieredPricingPriceElements = this.querySelectorAll('tiered-pricing-price');
      this.tiers = window.tieredPricing.tiers;

      // Quantity selector
      this.quantityInputElements = this.querySelectorAll('quantity-input[data-quantity-input-behavior="single"]');
      this.quantityInputElements.forEach(element => {
        this.quantityInput = element.querySelector('input');
        this.preventDiscount = (element.dataset.preventDiscount === 'true');
  
        ['change', 'input'].forEach((inputEvent) => {
          this.quantityInput.addEventListener(inputEvent, ({ target }) => this.handlePriceAndBadge(target?.valueAsNumber ?? 1));
        });
      });

      // Tiered pricing badge
      this.tieredPricingBadgeElements = this.querySelectorAll('tiered-pricing-badge');

      this.tieredUnitPricingElements = this.querySelectorAll('tiered-pricing-unit-price');

      this.tieredPricingProgressContainer = this.querySelectorAll('tiered-pricing-progress-container');

      
      // window.setTimeout(() => {
      //   this.handleAllPricesAndBadges();
      // }, 200);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.handleAllPricesAndBadges());
      } else {
        this.handleAllPricesAndBadges();
      }
    }


    /**
     * Handle submit
     * @param {Object} e 
     * @returns void
     */
    async onSubmitHandler(e) {
      e.preventDefault();

      const submitButtons = this.querySelectorAll('[type="submit"]');

      submitButtons.forEach(element => {
        element.setAttribute('disabled', true);
        element.classList.add('loading');
      });

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        // ...this.cartNotification.getSectionsToRender().map((section) => section.id)
      ];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      try {
        const response = await fetch(`${routes.cart_add_url}`, config);
        const json = await response.json();

        // // Quantity error
        // if (response.status == 422) {
        //   this.cartNotification.setActiveElement(document.activeElement);
        //   this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
        //   return;
        // }

        // Update the window value
        window.tieredPricing.tiered_pricing_item_count = window.tieredPricing.tiered_pricing_item_count + (this.quantityInput.valueAsNumber * json.properties._tiered_pricing_count);
        
        this.cartDrawer.renderContents(json);
        this.cartDrawer.open();
        this.handleAllPricesAndBadges();
        this.resetQuantityInputs();
        
      } catch (error) {
        console.error(error);
      } finally {
        submitButtons.forEach(element => {
          element.classList.remove('loading');
          element.removeAttribute('disabled');
        });
      }
    }


    resetQuantityInputs() {
      this.quantityInputElements.forEach(element => {
        this.quantityInput = element.querySelector('input');
        this.quantityInput.defaultValue = 1;
        this.quantityInput.value = 1;
      });

    }


    /**
     * Handle price and badge
     * @param {Number} valueAsNumber 
     */
    handlePriceAndBadge(valueAsNumber) {
      this.tiers.forEach(({ tiered_pricing_threshold, tiered_pricing_discount }) => {
        this.tieredPricingPriceElements.forEach(element => {
          element.handlePrice(valueAsNumber, tiered_pricing_threshold, tiered_pricing_discount);
        });
        this.tieredPricingBadgeElements.forEach(element => {
          element.handleBadge(valueAsNumber, tiered_pricing_threshold, tiered_pricing_discount);
        });
        this.tieredUnitPricingElements.forEach(element => {
          element.handleUnitPrice(valueAsNumber, tiered_pricing_threshold, tiered_pricing_discount);
        });
      });
      this.handleQuantityDiscountSnippet(valueAsNumber);
    }
    

    /**
     * Handle all prices and badges
     */
    handleAllPricesAndBadges() {
      const tiers = window.tieredPricing.tiers;
      
      const pricesElements = document.querySelectorAll('tiered-pricing-price');
      const badgesElements = document.querySelectorAll('tiered-pricing-badge');

      tiers.forEach(({ tiered_pricing_threshold, tiered_pricing_discount }) => {
        pricesElements.forEach(element => element.handlePrice(false, tiered_pricing_threshold, tiered_pricing_discount));
        badgesElements.forEach(element => element.handleBadge(false, tiered_pricing_threshold, tiered_pricing_discount));
      });
      this.handleQuantityDiscountSnippet();
    }

    handleQuantityDiscountSnippet(valueAsNumber = 1) {
      let progress = 0;
      let oneProductDiscount = 0;
      if (this.tiers[0].tiered_pricing_threshold == 1 && this.tiers[0].tiered_pricing_discount > 0) {
        oneProductDiscount = 1;
      }
      let tieredPricingItemCount  = window.tieredPricing.tiered_pricing_item_count ?? 0;
      progress = ((valueAsNumber * tieredPricingItemCount) / (this.tiers.length + 1 - (oneProductDiscount))) * 100;
      const progressBar = this.querySelector('.progress-bar');
      if (progress >= 100) { progress = 100; }
      if (progressBar) {
        progressBar.style.width = progress + '%';
      }
    }

    /**
     * Handle variant change
     */
    handleVariantSelect() {
      this.variants.options[this.variants.selectedIndex].value && (window.location = this.variants.options[this.variants.selectedIndex].value)
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}


